import _ from 'lodash';

export default function initZelect() {
  const $zelect = $('select.zelect:not(.loaded)');
  $zelect.addClass('loaded');
  $zelect.zelect({
    placeholder: $zelect.data('placeholder'),
    renderItem: (item) => {
      if (_.isNil(item)) {
        return '';
      } else if ($.type(item) === 'string') {
        return item;
      } else if (!_.isNil(item.label)) {
        return item.label || $('<span />').html('&nbsp;');
      } else if (item.toString) {
        return item.toString();
      }
      return item;
    },
  });
}

$(document).on('ready turbolinks:load', () => {
  initZelect();
});
